export enum CalibrationState {
  CREATED = 'created',
  SUBMITTED = 'submitted',
  FAILED = 'failed',
  /**
   * When a calibration has been completed but there has been a change in the settings. Ie, if ran again, the results may be different from the current results
   */
  MODIFIED = 'modified',
  COMPLETED = 'completed',
}
